import { Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from 'src/app/services/permission.service';

@Pipe({
  name: 'permission',
})
export class PermissionPipe implements PipeTransform {
  constructor(private service: PermissionService) {}

  transform(arr: string[]): boolean {
    let perms: string[] = this.service.GetPermissions();

    if (perms == undefined || perms.length <= 0) {
      return false;
    }
    for (let i = 0; i < arr.length; i++) {
      if (perms.filter((e) => e == arr[i]).length > 0) {
        return true;
      }
    }
    return false;
  }
}
